module.exports = __webpack_public_path__ + "img/locationAP.2b5f6947.png";